import { render, staticRenderFns } from "./BGrimmTaxInvoiceSubPage.vue?vue&type=template&id=d68894cc&scoped=true&"
import script from "./BGrimmTaxInvoiceSubPage.vue?vue&type=script&lang=js&"
export * from "./BGrimmTaxInvoiceSubPage.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=d68894cc&scoped=true&lang=css&"
import style1 from "./BGrimmTaxInvoiceSubPage.vue?vue&type=style&index=1&id=d68894cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68894cc",
  null
  
)

export default component.exports